
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
    collection,
    query,
    where,
    onSnapshot,
    limit,
    getDocs,
    runTransaction,
  } from "firebase/firestore";
  
import { db } from "../firebase";
import "./CopyTrading.css";
import BottomNavCopyTrading from "../Components/BottomNavCopyTrading";

const CRYPTO_PAIRS = [
    "BTC-USDT",
    "ETH-USDT",
    "SOL-USDT",
    "XRP-USDT",
    "ADA-USDT",
    "DOGE-USDT",
    "TRX-USDT",
    "OKB-USDT",
    "BNB-USDT",
    "LTC-USDT",
    "BCH-USDT",
    "DOT-USDT",
    "LINK-USDT",
    "AVAX-USDT",
    "TON-USDT",
    "SHIB-USDT",
    "PEPE-USDT",
  ];
  
  const FOREX_PAIRS = [
    "AUDCAD",
    "AUDCHF",
    "AUDJPY",
    "AUDNZD",
    "AUDUSD",
    "EURAUD",
    "EURUSD",
    "EURGBP",
    "EURJPY",
    "EURNZD",
    "GBPUSD",
    "NZDUSD",
  ];

  export const traders = [
    {
        "id": 1,
        "name": "Neema Mwakalinga",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 4.9,
        "win": 59.3,
        "followers": 1491,
        "copiers": 1454,
        "aum": 30371,
        "risk": "Medium",
        "ret": 8.67,
        "avatar": "👩🏻",
        "curve": [-
    
          50,
          39,
          55,
          71,
          33
        ],
        "verified": true
      },
      {
        "id": 2,
        "name": "Asha Suleiman",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 6.6,
        "win": 60.6,
        "followers": 2282,
        "copiers": 2208,
        "aum": 48742,
        "risk": "High",
        "ret": 13.46,
        "avatar": "🧑🏽‍💻",
        "curve": [
          34,
          64,
          36,
          53,
          67
        ],
        "verified": true
      },
      {
        "id": 3,
        "name": "Juma Kweka",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 8.3,
        "win": 61.9,
        "followers": 3073,
        "copiers": 2962,
        "aum": 67113,
        "risk": "Low",
        "ret": 19.17,
        "avatar": "🧔🏾",
        "curve": [
          33,
          62,
          43,
          32,
          35
        ],
        "verified": true
      },
      {
        "id": 4,
        "name": "Baraka Mushi",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 10.0,
        "win": 63.2,
        "followers": 3864,
        "copiers": 3716,
        "aum": 85484,
        "risk": "High",
        "ret": 25.8,
        "avatar": "₿",
        "curve": [
          57,
          56,
          34,
          45,
          35
        ],
        "verified": true
      },
      {
        "id": 5,
        "name": "Zawadi Nyerere",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 11.7,
        "win": 64.5,
        "followers": 4655,
        "copiers": 4650,
        "aum": 103855,
        "risk": "Low",
        "ret": 33.34,
        "avatar": "🦊",
        "curve": [
          65,
          57,
          33,
          66,
          37
        ],
        "verified": true
      },
      {
        "id": 6,
        "name": "Faraja Mtemi",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 13.4,
        "win": 65.8,
        "followers": 5446,
        "copiers": 5404,
        "aum": 122226,
        "risk": "Medium",
        "ret": 41.81,
        "avatar": "🌙",
        "curve": [
          44,
          70,
          70,
          67,
          33
        ],
        "verified": true
      },
      {
        "id": 7,
        "name": "Rehema Juma",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 15.1,
        "win": 67.1,
        "followers": 6237,
        "copiers": 6158,
        "aum": 140597,
        "risk": "High",
        "ret": 22.65,
        "avatar": "👩🏾",
        "curve": [
          66,
          67,
          55,
          33,
          44
        ],
        "verified": true
      },
      {
        "id": 8,
        "name": "Kassim Omari",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 16.8,
        "win": 68.4,
        "followers": 7028,
        "copiers": 6912,
        "aum": 158968,
        "risk": "Medium",
        "ret": 29.74,
        "avatar": "👨🏻‍💼",
        "curve": [
          32,
          65,
          38,
          48,
          56
        ],
        "verified": true
      },
      {
        "id": 9,
        "name": "Mariam Bakari",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 18.5,
        "win": 69.7,
        "followers": 7819,
        "copiers": 7666,
        "aum": 177339,
        "risk": "High",
        "ret": 37.74,
        "avatar": "👨🏻",
        "curve": [
          39,
          64,
          37,
          66,
          49
        ],
        "verified": true
      },
      {
        "id": 10,
        "name": "Hassan Mwinyi",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 20.2,
        "win": 71.0,
        "followers": 8610,
        "copiers": 8600,
        "aum": 195710,
        "risk": "Low",
        "ret": 46.66,
        "avatar": "🐼",
        "curve": [
          65,
          73,
          41,
          36,
          67
        ],
        "verified": true
      },
      {
        "id": 11,
        "name": "Ananya Sharma",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 21.9,
        "win": 72.3,
        "followers": 9401,
        "copiers": 9354,
        "aum": 214081,
        "risk": "Medium",
        "ret": 56.5,
        "avatar": "🌐",
        "curve": [
          66,
          70,
          42,
          53,
          36
        ],
        "verified": true
      },
      {
        "id": 12,
        "name": "Rohan Mehta",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 23.6,
        "win": 73.6,
        "followers": 10192,
        "copiers": 10108,
        "aum": 232452,
        "risk": "Low",
        "ret": 67.26,
        "avatar": "🐉",
        "curve": [
          65,
          75,
          34,
          66,
          33
        ],
        "verified": true
      },
      {
        "id": 13,
        "name": "Priya Iyer",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 25.3,
        "win": 74.9,
        "followers": 10983,
        "copiers": 10862,
        "aum": 250823,
        "risk": "Medium",
        "ret": 78.94,
        "avatar": "⚡",
        "curve": [
          69,
          43,
          61,
          73,
          64
        ],
        "verified": true
      },
      {
        "id": 14,
        "name": "Arjun Kapoor",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 27.0,
        "win": 76.2,
        "followers": 11774,
        "copiers": 11616,
        "aum": 269194,
        "risk": "High",
        "ret": 40.5,
        "avatar": "🧔🏻",
        "curve": [
          57,
          50,
          59,
          67,
          59
        ],
        "verified": true
      },
      {
        "id": 15,
        "name": "Kavya Patel",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 28.7,
        "win": 77.5,
        "followers": 12565,
        "copiers": 12550,
        "aum": 287565,
        "risk": "Low",
        "ret": 50.8,
        "avatar": "👩🏽‍🦱",
        "curve": [
          53,
          49,
          45,
          41,
          74
        ],
        "verified": true
      },
      {
        "id": 16,
        "name": "Li Wei",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 30.4,
        "win": 78.8,
        "followers": 1356,
        "copiers": 1304,
        "aum": 305936,
        "risk": "High",
        "ret": 62.02,
        "avatar": "👩🏼",
        "curve": [
          45,
          35,
          66,
          49,
          63
        ],
        "verified": true
      },
      {
        "id": 17,
        "name": "Chen Xiaoyu",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 32.1,
        "win": 80.1,
        "followers": 2147,
        "copiers": 2058,
        "aum": 324307,
        "risk": "Low",
        "ret": 74.15,
        "avatar": "🐯",
        "curve": [
          61,
          51,
          58,
          48,
          68
        ],
        "verified": true
      },
      {
        "id": 18,
        "name": "Wang Jun",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 33.8,
        "win": 81.4,
        "followers": 2938,
        "copiers": 2812,
        "aum": 342678,
        "risk": "Medium",
        "ret": 87.2,
        "avatar": "🚀",
        "curve": [
          34,
          37,
          62,
          56,
          40
        ],
        "verified": true
      },
      {
        "id": 19,
        "name": "Zhang Min",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 35.5,
        "win": 82.7,
        "followers": 3729,
        "copiers": 3566,
        "aum": 361049,
        "risk": "High",
        "ret": 101.17,
        "avatar": "🪙",
        "curve": [
          51,
          39,
          61,
          56,
          32
        ],
        "verified": true
      },
      {
        "id": 20,
        "name": "Liu Haoran",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 37.2,
        "win": 84.0,
        "followers": 4520,
        "copiers": 4500,
        "aum": 379420,
        "risk": "Medium",
        "ret": 116.06,
        "avatar": "👨🏽",
        "curve": [
          72,
          34,
          65,
          66,
          50
        ],
        "verified": true
      },
      {
        "id": 21,
        "name": "Mei Lin",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 38.9,
        "win": 85.3,
        "followers": 5311,
        "copiers": 5254,
        "aum": 397791,
        "risk": "High",
        "ret": 58.35,
        "avatar": "👩🏻",
        "curve": [
          51,
          74,
          52,
          68,
          61
        ],
        "verified": true
      },
      {
        "id": 22,
        "name": "Yuki Tanaka",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 40.6,
        "win": 86.6,
        "followers": 6102,
        "copiers": 6008,
        "aum": 416162,
        "risk": "Low",
        "ret": 71.86,
        "avatar": "🧑🏽‍💻",
        "curve": [
          67,
          59,
          34,
          35,
          47
        ],
        "verified": true
      },
      {
        "id": 23,
        "name": "Haruto Sato",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 42.3,
        "win": 87.9,
        "followers": 6893,
        "copiers": 6762,
        "aum": 434533,
        "risk": "Medium",
        "ret": 86.29,
        "avatar": "🧔🏾",
        "curve": [
          60,
          74,
          72,
          34,
          33
        ],
        "verified": true
      },
      {
        "id": 24,
        "name": "Min-jun Kim",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 44.0,
        "win": 89.2,
        "followers": 7684,
        "copiers": 7516,
        "aum": 452904,
        "risk": "Low",
        "ret": 101.64,
        "avatar": "₿",
        "curve": [
          74,
          49,
          71,
          66,
          73
        ],
        "verified": true
      },
      {
        "id": 25,
        "name": "Seo-yeon Park",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 3.7,
        "win": 90.5,
        "followers": 8475,
        "copiers": 8450,
        "aum": 471275,
        "risk": "Medium",
        "ret": 9.55,
        "avatar": "🦊",
        "curve": [
          58,
          48,
          75,
          54,
          72
        ],
        "verified": true
      },
      {
        "id": 26,
        "name": "Amir Haddad",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 5.4,
        "win": 91.8,
        "followers": 9266,
        "copiers": 9204,
        "aum": 489646,
        "risk": "High",
        "ret": 15.39,
        "avatar": "🌙",
        "curve": [
          52,
          31,
          59,
          52,
          40
        ],
        "verified": true
      },
      {
        "id": 27,
        "name": "Layla Mansour",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 7.1,
        "win": 58.1,
        "followers": 10057,
        "copiers": 9958,
        "aum": 508017,
        "risk": "Low",
        "ret": 22.15,
        "avatar": "👩🏾",
        "curve": [
          69,
          37,
          61,
          33,
          43
        ],
        "verified": true
      },
      {
        "id": 28,
        "name": "Omar Khalil",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 8.8,
        "win": 59.4,
        "followers": 10848,
        "copiers": 10712,
        "aum": 526388,
        "risk": "High",
        "ret": 13.2,
        "avatar": "👨🏻‍💼",
        "curve": [
          48,
          38,
          45,
          55,
          55
        ],
        "verified": true
      },
      {
        "id": 29,
        "name": "Nadia Rahman",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 10.5,
        "win": 60.7,
        "followers": 11639,
        "copiers": 11466,
        "aum": 544759,
        "risk": "Low",
        "ret": 18.59,
        "avatar": "👨🏻",
        "curve": [
          61,
          35,
          40,
          58,
          55
        ],
        "verified": true
      },
      {
        "id": 30,
        "name": "Fatima Zahra",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 12.2,
        "win": 62.0,
        "followers": 12430,
        "copiers": 12400,
        "aum": 563130,
        "risk": "Medium",
        "ret": 24.89,
        "avatar": "🐼",
        "curve": [
          65,
          47,
          38,
          57,
          65
        ],
        "verified": true
      },
      {
        "id": 31,
        "name": "Daniel Brooks",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 13.9,
        "win": 63.3,
        "followers": 1221,
        "copiers": 1154,
        "aum": 581501,
        "risk": "High",
        "ret": 32.11,
        "avatar": "🌐",
        "curve": [
          47,
          75,
          56,
          52,
          73
        ],
        "verified": true
      },
      {
        "id": 32,
        "name": "Olivia Carter",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 15.6,
        "win": 64.6,
        "followers": 2012,
        "copiers": 1908,
        "aum": 599872,
        "risk": "Medium",
        "ret": 40.25,
        "avatar": "🐉",
        "curve": [
          54,
          44,
          39,
          35,
          41
        ],
        "verified": true
      },
      {
        "id": 33,
        "name": "Noah Bennett",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 17.3,
        "win": 65.9,
        "followers": 2803,
        "copiers": 2662,
        "aum": 618243,
        "risk": "High",
        "ret": 49.31,
        "avatar": "⚡",
        "curve": [
          39,
          44,
          72,
          44,
          30
        ],
        "verified": true
      },
      {
        "id": 34,
        "name": "Mia Collins",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 19.0,
        "win": 67.2,
        "followers": 3594,
        "copiers": 3416,
        "aum": 636614,
        "risk": "Low",
        "ret": 59.28,
        "avatar": "🧔🏻",
        "curve": [
          61,
          67,
          41,
          46,
          48
        ],
        "verified": true
      },
      {
        "id": 35,
        "name": "Ethan Walker",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 20.7,
        "win": 68.5,
        "followers": 4385,
        "copiers": 4350,
        "aum": 654985,
        "risk": "Medium",
        "ret": 31.05,
        "avatar": "👩🏽‍🦱",
        "curve": [
          30,
          39,
          56,
          64,
          53
        ],
        "verified": true
      },
      {
        "id": 36,
        "name": "Sofia Rossi",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 22.4,
        "win": 69.8,
        "followers": 5176,
        "copiers": 5104,
        "aum": 673356,
        "risk": "Low",
        "ret": 39.65,
        "avatar": "👩🏼",
        "curve": [
          69,
          66,
          50,
          38,
          74
        ],
        "verified": true
      },
      {
        "id": 37,
        "name": "Luca Bianchi",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 24.1,
        "win": 71.1,
        "followers": 5967,
        "copiers": 5858,
        "aum": 691727,
        "risk": "Medium",
        "ret": 49.16,
        "avatar": "🐯",
        "curve": [
          62,
          69,
          71,
          73,
          33
        ],
        "verified": true
      },
      {
        "id": 38,
        "name": "Ines Moreau",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 25.8,
        "win": 72.4,
        "followers": 6758,
        "copiers": 6612,
        "aum": 710098,
        "risk": "High",
        "ret": 59.6,
        "avatar": "🚀",
        "curve": [
          59,
          73,
          65,
          55,
          55
        ],
        "verified": true
      },
      {
        "id": 39,
        "name": "Mateo Silva",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 27.5,
        "win": 73.7,
        "followers": 7549,
        "copiers": 7546,
        "aum": 728469,
        "risk": "Low",
        "ret": 70.95,
        "avatar": "🪙",
        "curve": [
          55,
          55,
          36,
          60,
          70
        ],
        "verified": true
      },
      {
        "id": 40,
        "name": "Isabella Costa",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 29.2,
        "win": 75.0,
        "followers": 8340,
        "copiers": 8300,
        "aum": 746840,
        "risk": "High",
        "ret": 83.22,
        "avatar": "👨🏽",
        "curve": [
          55,
          33,
          42,
          34,
          43
        ],
        "verified": true
      },
      {
        "id": 41,
        "name": "Thabo Nkosi",
        "type": "Forex",
        "style": "BFctrade Swing",
        "roi": 30.9,
        "win": 76.3,
        "followers": 9131,
        "copiers": 9054,
        "aum": 765211,
        "risk": "Low",
        "ret": 96.41,
        "avatar": "👩🏻",
        "curve": [
          58,
          40,
          37,
          51,
          68
        ],
        "verified": true
      },
      {
        "id": 42,
        "name": "Lerato Dlamini",
        "type": "Forex",
        "style": "BFctrade Balanced",
        "roi": 32.6,
        "win": 77.6,
        "followers": 9922,
        "copiers": 9808,
        "aum": 783582,
        "risk": "Medium",
        "ret": 48.9,
        "avatar": "🧑🏽‍💻",
        "curve": [
          33,
          36,
          30,
          66,
          39
        ],
        "verified": true
      },
      {
        "id": 43,
        "name": "Kwame Mensah",
        "type": "Forex",
        "style": "BFctrade Trend",
        "roi": 34.3,
        "win": 78.9,
        "followers": 10713,
        "copiers": 10562,
        "aum": 801953,
        "risk": "High",
        "ret": 60.71,
        "avatar": "🧔🏾",
        "curve": [
          64,
          36,
          53,
          69,
          31
        ],
        "verified": true
      },
      {
        "id": 44,
        "name": "Ama Boateng",
        "type": "Forex",
        "style": "BFctrade Momentum",
        "roi": 36.0,
        "win": 80.2,
        "followers": 11504,
        "copiers": 11496,
        "aum": 820324,
        "risk": "Medium",
        "ret": 73.44,
        "avatar": "₿",
        "curve": [
          34,
          43,
          69,
          54,
          39
        ],
        "verified": true
      },
      {
        "id": 45,
        "name": "Chinedu Okafor",
        "type": "Forex",
        "style": "BFctrade Signals",
        "roi": 37.7,
        "win": 81.5,
        "followers": 12295,
        "copiers": 12250,
        "aum": 838695,
        "risk": "High",
        "ret": 87.09,
        "avatar": "🦊",
        "curve": [
          70,
          46,
          52,
          68,
          53
        ],
        "verified": true
      },
      {
        "id": 46,
        "name": "Bitcoin Bwana",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 39.4,
        "win": 82.8,
        "followers": 1086,
        "copiers": 1004,
        "aum": 857066,
        "risk": "Low",
        "ret": 101.65,
        "avatar": "🌙",
        "curve": [
          60,
          37,
          37,
          61,
          59
        ],
        "verified": true
      },
      {
        "id": 47,
        "name": "Satoshi Mtemi",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 41.1,
        "win": 84.1,
        "followers": 1877,
        "copiers": 1758,
        "aum": 875437,
        "risk": "Medium",
        "ret": 117.14,
        "avatar": "👩🏾",
        "curve": [
          60,
          60,
          49,
          35,
          39
        ],
        "verified": true
      },
      {
        "id": 48,
        "name": "Musa Crypto",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 42.8,
        "win": 85.4,
        "followers": 2668,
        "copiers": 2512,
        "aum": 893808,
        "risk": "Low",
        "ret": 133.54,
        "avatar": "👨🏻‍💼",
        "curve": [
          36,
          51,
          46,
          60,
          74
        ],
        "verified": true
      },
      {
        "id": 49,
        "name": "Amina Kweka",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 44.5,
        "win": 86.7,
        "followers": 3459,
        "copiers": 3446,
        "aum": 912179,
        "risk": "Medium",
        "ret": 66.75,
        "avatar": "👨🏻",
        "curve": [
          40,
          63,
          31,
          43,
          63
        ],
        "verified": true
      },
      {
        "id": 50,
        "name": "Kito Digital",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 4.2,
        "win": 88.0,
        "followers": 4250,
        "copiers": 4200,
        "aum": 930550,
        "risk": "High",
        "ret": 7.43,
        "avatar": "🐼",
        "curve": [
          53,
          39,
          74,
          64,
          31
        ],
        "verified": true
      },
      {
        "id": 51,
        "name": "Zuri Blockchain",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 5.9,
        "win": 89.3,
        "followers": 5041,
        "copiers": 4954,
        "aum": 28921,
        "risk": "Low",
        "ret": 12.04,
        "avatar": "🌐",
        "curve": [
          63,
          49,
          71,
          35,
          74
        ],
        "verified": true
      },
      {
        "id": 52,
        "name": "Pendo Coin",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 7.6,
        "win": 90.6,
        "followers": 5832,
        "copiers": 5708,
        "aum": 47292,
        "risk": "High",
        "ret": 17.56,
        "avatar": "🐉",
        "curve": [
          46,
          63,
          53,
          40,
          52
        ],
        "verified": true
      },
      {
        "id": 53,
        "name": "Mfalme wa Soko",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 9.3,
        "win": 91.9,
        "followers": 6623,
        "copiers": 6462,
        "aum": 65663,
        "risk": "Low",
        "ret": 23.99,
        "avatar": "⚡",
        "curve": [
          44,
          64,
          64,
          62,
          51
        ],
        "verified": true
      },
      {
        "id": 54,
        "name": "Nuru Hash",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 11.0,
        "win": 58.2,
        "followers": 7414,
        "copiers": 7396,
        "aum": 84034,
        "risk": "Medium",
        "ret": 31.35,
        "avatar": "🧔🏻",
        "curve": [
          70,
          44,
          69,
          42,
          45
        ],
        "verified": true
      },
      {
        "id": 55,
        "name": "Jabali Web3",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 12.7,
        "win": 59.5,
        "followers": 8205,
        "copiers": 8150,
        "aum": 102405,
        "risk": "High",
        "ret": 39.62,
        "avatar": "👩🏽‍🦱",
        "curve": [
          55,
          44,
          42,
          63,
          61
        ],
        "verified": true
      },
      {
        "id": 56,
        "name": "Vikram Desai",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 14.4,
        "win": 60.8,
        "followers": 8996,
        "copiers": 8904,
        "aum": 120776,
        "risk": "Medium",
        "ret": 21.6,
        "avatar": "👩🏼",
        "curve": [
          52,
          31,
          31,
          47,
          60
        ],
        "verified": true
      },
      {
        "id": 57,
        "name": "Ishaan Verma",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 16.1,
        "win": 62.1,
        "followers": 9787,
        "copiers": 9658,
        "aum": 139147,
        "risk": "High",
        "ret": 28.5,
        "avatar": "🐯",
        "curve": [
          46,
          42,
          74,
          68,
          52
        ],
        "verified": true
      },
      {
        "id": 58,
        "name": "Diya Kapoor",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 17.8,
        "win": 63.4,
        "followers": 10578,
        "copiers": 10412,
        "aum": 157518,
        "risk": "Low",
        "ret": 36.31,
        "avatar": "🚀",
        "curve": [
          58,
          52,
          53,
          35,
          44
        ],
        "verified": true
      },
      {
        "id": 59,
        "name": "Rahul Nair",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 19.5,
        "win": 64.7,
        "followers": 11369,
        "copiers": 11346,
        "aum": 175889,
        "risk": "Medium",
        "ret": 45.05,
        "avatar": "🪙",
        "curve": [
          36,
          44,
          60,
          42,
          51
        ],
        "verified": true
      },
      {
        "id": 60,
        "name": "Meera Joshi",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 21.2,
        "win": 66.0,
        "followers": 12160,
        "copiers": 12100,
        "aum": 194260,
        "risk": "Low",
        "ret": 54.7,
        "avatar": "👨🏽",
        "curve": [
          43,
          60,
          69,
          69,
          30
        ],
        "verified": true
      },
      {
        "id": 61,
        "name": "Long Chen",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 22.9,
        "win": 67.3,
        "followers": 951,
        "copiers": 854,
        "aum": 212631,
        "risk": "Medium",
        "ret": 65.27,
        "avatar": "👩🏻",
        "curve": [
          60,
          71,
          52,
          71,
          35
        ],
        "verified": true
      },
      {
        "id": 62,
        "name": "Xiao Lin",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 24.6,
        "win": 68.6,
        "followers": 1742,
        "copiers": 1608,
        "aum": 231002,
        "risk": "High",
        "ret": 76.75,
        "avatar": "🧑🏽‍💻",
        "curve": [
          72,
          37,
          54,
          75,
          42
        ],
        "verified": true
      },
      {
        "id": 63,
        "name": "Zhao Ming",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 26.3,
        "win": 69.9,
        "followers": 2533,
        "copiers": 2362,
        "aum": 249373,
        "risk": "Low",
        "ret": 39.45,
        "avatar": "🧔🏾",
        "curve": [
          60,
          41,
          57,
          70,
          51
        ],
        "verified": true
      },
      {
        "id": 64,
        "name": "Huang Yue",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 28.0,
        "win": 71.2,
        "followers": 3324,
        "copiers": 3296,
        "aum": 267744,
        "risk": "High",
        "ret": 49.56,
        "avatar": "₿",
        "curve": [
          35,
          55,
          59,
          55,
          35
        ],
        "verified": true
      },
      {
        "id": 65,
        "name": "Jin Tao",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 29.7,
        "win": 72.5,
        "followers": 4115,
        "copiers": 4050,
        "aum": 286115,
        "risk": "Low",
        "ret": 60.59,
        "avatar": "🦊",
        "curve": [
          40,
          40,
          38,
          31,
          39
        ],
        "verified": true
      },
      {
        "id": 66,
        "name": "Akira Nakamura",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 31.4,
        "win": 73.8,
        "followers": 4906,
        "copiers": 4804,
        "aum": 304486,
        "risk": "Medium",
        "ret": 72.53,
        "avatar": "🌙",
        "curve": [
          67,
          59,
          71,
          39,
          69
        ],
        "verified": true
      },
      {
        "id": 67,
        "name": "Sora Fujimoto",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 33.1,
        "win": 75.1,
        "followers": 5697,
        "copiers": 5558,
        "aum": 322857,
        "risk": "High",
        "ret": 85.4,
        "avatar": "👩🏾",
        "curve": [
          68,
          60,
          72,
          52,
          39
        ],
        "verified": true
      },
      {
        "id": 68,
        "name": "Hana Suzuki",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 34.8,
        "win": 76.4,
        "followers": 6488,
        "copiers": 6312,
        "aum": 341228,
        "risk": "Medium",
        "ret": 99.18,
        "avatar": "👨🏻‍💼",
        "curve": [
          65,
          65,
          38,
          31,
          30
        ],
        "verified": true
      },
      {
        "id": 69,
        "name": "Ji-ho Lee",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 36.5,
        "win": 77.7,
        "followers": 7279,
        "copiers": 7246,
        "aum": 359599,
        "risk": "High",
        "ret": 113.88,
        "avatar": "👨🏻",
        "curve": [
          71,
          36,
          63,
          38,
          57
        ],
        "verified": true
      },
      {
        "id": 70,
        "name": "Yuna Choi",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 38.2,
        "win": 79.0,
        "followers": 8070,
        "copiers": 8000,
        "aum": 377970,
        "risk": "Low",
        "ret": 57.3,
        "avatar": "🐼",
        "curve": [
          42,
          43,
          31,
          46,
          43
        ],
        "verified": true
      },
      {
        "id": 71,
        "name": "Samir Qureshi",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 39.9,
        "win": 80.3,
        "followers": 8861,
        "copiers": 8754,
        "aum": 396341,
        "risk": "Medium",
        "ret": 70.62,
        "avatar": "🌐",
        "curve": [
          48,
          62,
          45,
          67,
          50
        ],
        "verified": true
      },
      {
        "id": 72,
        "name": "Zain Abbas",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 41.6,
        "win": 81.6,
        "followers": 9652,
        "copiers": 9508,
        "aum": 414712,
        "risk": "Low",
        "ret": 84.86,
        "avatar": "🐉",
        "curve": [
          46,
          64,
          56,
          38,
          33
        ],
        "verified": true
      },
      {
        "id": 73,
        "name": "Maryam Noor",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 43.3,
        "win": 82.9,
        "followers": 10443,
        "copiers": 10442,
        "aum": 433083,
        "risk": "Medium",
        "ret": 100.02,
        "avatar": "⚡",
        "curve": [
          52,
          59,
          72,
          67,
          63
        ],
        "verified": true
      },
      {
        "id": 74,
        "name": "Tariq Aziz",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 45.0,
        "win": 84.2,
        "followers": 11234,
        "copiers": 11196,
        "aum": 451454,
        "risk": "High",
        "ret": 116.1,
        "avatar": "🧔🏻",
        "curve": [
          56,
          62,
          38,
          64,
          39
        ],
        "verified": true
      },
      {
        "id": 75,
        "name": "Salma Idris",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 4.7,
        "win": 85.5,
        "followers": 12025,
        "copiers": 11950,
        "aum": 469825,
        "risk": "Low",
        "ret": 13.4,
        "avatar": "👩🏽‍🦱",
        "curve": [
          63,
          62,
          31,
          58,
          41
        ],
        "verified": true
      },
      {
        "id": 76,
        "name": "Alex Morgan",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 6.4,
        "win": 86.8,
        "followers": 816,
        "copiers": 704,
        "aum": 488196,
        "risk": "High",
        "ret": 19.97,
        "avatar": "👩🏼",
        "curve": [
          68,
          30,
          39,
          41,
          39
        ],
        "verified": true
      },
      {
        "id": 77,
        "name": "Jordan Blake",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 8.1,
        "win": 88.1,
        "followers": 1607,
        "copiers": 1458,
        "aum": 506567,
        "risk": "Low",
        "ret": 12.15,
        "avatar": "🐯",
        "curve": [
          60,
          69,
          37,
          65,
          33
        ],
        "verified": true
      },
      {
        "id": 78,
        "name": "Taylor Reed",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 9.8,
        "win": 89.4,
        "followers": 2398,
        "copiers": 2392,
        "aum": 524938,
        "risk": "Medium",
        "ret": 17.35,
        "avatar": "🚀",
        "curve": [
          50,
          73,
          63,
          63,
          65
        ],
        "verified": true
      },
      {
        "id": 79,
        "name": "Avery Quinn",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 11.5,
        "win": 90.7,
        "followers": 3189,
        "copiers": 3146,
        "aum": 543309,
        "risk": "High",
        "ret": 23.46,
        "avatar": "🪙",
        "curve": [
          60,
          36,
          65,
          33,
          45
        ],
        "verified": true
      },
      {
        "id": 80,
        "name": "Riley James",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 13.2,
        "win": 92.0,
        "followers": 3980,
        "copiers": 3900,
        "aum": 561680,
        "risk": "Medium",
        "ret": 30.49,
        "avatar": "👨🏽",
        "curve": [
          42,
          47,
          32,
          36,
          62
        ],
        "verified": true
      },
      {
        "id": 81,
        "name": "Diego Herrera",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 14.9,
        "win": 58.3,
        "followers": 4771,
        "copiers": 4654,
        "aum": 580051,
        "risk": "High",
        "ret": 38.44,
        "avatar": "👩🏻",
        "curve": [
          58,
          65,
          31,
          34,
          58
        ],
        "verified": true
      },
      {
        "id": 82,
        "name": "Camila Torres",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 16.6,
        "win": 59.6,
        "followers": 5562,
        "copiers": 5408,
        "aum": 598422,
        "risk": "Low",
        "ret": 47.31,
        "avatar": "🧑🏽‍💻",
        "curve": [
          50,
          69,
          62,
          68,
          62
        ],
        "verified": true
      },
      {
        "id": 83,
        "name": "Valentina Cruz",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 18.3,
        "win": 60.9,
        "followers": 6353,
        "copiers": 6342,
        "aum": 616793,
        "risk": "Medium",
        "ret": 57.1,
        "avatar": "🧔🏾",
        "curve": [
          42,
          74,
          47,
          58,
          62
        ],
        "verified": true
      },
      {
        "id": 84,
        "name": "Pablo Reyes",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 20.0,
        "win": 62.2,
        "followers": 7144,
        "copiers": 7096,
        "aum": 635164,
        "risk": "Low",
        "ret": 30.0,
        "avatar": "₿",
        "curve": [
          64,
          60,
          62,
          45,
          74
        ],
        "verified": true
      },
      {
        "id": 85,
        "name": "Lucia Fernandez",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 21.7,
        "win": 63.5,
        "followers": 7935,
        "copiers": 7850,
        "aum": 653535,
        "risk": "Medium",
        "ret": 38.41,
        "avatar": "🦊",
        "curve": [
          63,
          46,
          65,
          42,
          58
        ],
        "verified": true
      },
      {
        "id": 86,
        "name": "Kwesi Addo",
        "type": "Crypto",
        "style": "BFctrade Swing",
        "roi": 23.4,
        "win": 64.8,
        "followers": 8726,
        "copiers": 8604,
        "aum": 671906,
        "risk": "High",
        "ret": 47.74,
        "avatar": "🌙",
        "curve": [
          38,
          56,
          37,
          55,
          58
        ],
        "verified": true
      },
      {
        "id": 87,
        "name": "Nia Okonkwo",
        "type": "Crypto",
        "style": "BFctrade Balanced",
        "roi": 25.1,
        "win": 66.1,
        "followers": 9517,
        "copiers": 9358,
        "aum": 690277,
        "risk": "Low",
        "ret": 57.98,
        "avatar": "👩🏾",
        "curve": [
          50,
          34,
          72,
          45,
          57
        ],
        "verified": true
      },
      {
        "id": 88,
        "name": "Sipho Mokoena",
        "type": "Crypto",
        "style": "BFctrade Trend",
        "roi": 26.8,
        "win": 67.4,
        "followers": 10308,
        "copiers": 10292,
        "aum": 708648,
        "risk": "High",
        "ret": 69.14,
        "avatar": "👨🏻‍💼",
        "curve": [
          34,
          43,
          72,
          49,
          37
        ],
        "verified": true
      },
      {
        "id": 89,
        "name": "Amara Diallo",
        "type": "Crypto",
        "style": "BFctrade Momentum",
        "roi": 28.5,
        "win": 68.7,
        "followers": 11099,
        "copiers": 11046,
        "aum": 727019,
        "risk": "Low",
        "ret": 81.23,
        "avatar": "👨🏻",
        "curve": [
          39,
          75,
          71,
          72,
          53
        ],
        "verified": true
      },
      {
        "id": 90,
        "name": "Kofi Boateng",
        "type": "Crypto",
        "style": "BFctrade Signals",
        "roi": 30.2,
        "win": 70.0,
        "followers": 11890,
        "copiers": 11800,
        "aum": 745390,
        "risk": "Medium",
        "ret": 94.22,
        "avatar": "🐼",
        "curve": [
          39,
          46,
          38,
          59,
          44
        ],
        "verified": true
      }
    ];
    
 
const filters = [
    "Top Rated",
    "Highest ROI",
    "Most Copied",
    "Low Risk",
    "Popular Bots",
    "Future Copy Trading",
    "Sport Copy Trading",
    "Signal Marketplace",
  ];




const money = (n) =>
  n >= 1_000_000
    ? `$${(n / 1_000_000).toFixed(2)}M`
    : n >= 100_000
      ? `$${(n / 1000).toFixed(0)}K`
      : `$${n.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

const compact = (n) =>
  n >= 1000 ? `${(n / 1000).toFixed(1)}K` : n.toLocaleString();




function PerformanceLine({ values, risk }) {
  const points = values.map((v, i) => `${(i / (values.length - 1)) * 300},${v}`).join(" ");
  return (
    <svg viewBox="0 0 300 90" preserveAspectRatio="none" className="ct-performance" aria-label="Demo performance line">
      <line x1="0" y1="85" x2="300" y2="85" stroke="#202938" />
      <polyline points={points} fill="none" stroke={risk === "High" ? "#ef5268" : "#42c99a"} strokeWidth="2" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}

const tradersWithPairs = traders.map((trader, index) => {
    const pairs =
      trader.type === "Crypto"
        ? CRYPTO_PAIRS
        : FOREX_PAIRS;
  
    const pairIndex =
      trader.type === "Crypto"
        ? (trader.id - 46) % CRYPTO_PAIRS.length
        : (trader.id - 1) % FOREX_PAIRS.length;
  
    return {
      ...trader,
      pair: pairs[(pairIndex + pairs.length) % pairs.length],
    };
  });

function TraderCard({ trader, rank, copied, onCopy, onDetails }) {
  return (
   
    <article className="ct-card">
<BottomNavCopyTrading/>

      <div className="ct-trader-head">
        <div className="ct-avatar-wrap">
          <span className={`ct-rank ${rank <= 3 ? "ct-medal" : ""}`}>{rank}</span>
          <div className="ct-avatar" aria-hidden="true">{trader.avatar}</div>
        </div>
        <div className="ct-trader-info">
          <div className="ct-name">{trader.name}

          {trader.verified && (
  <span className="ct-verified" title="Verified trader">
    ✓
  </span>
)}
          
          
          </div>

          <div className="ct-style">{trader.style}</div>
          <span className={`ct-market-tag ${trader.type === "Crypto" ? "crypto" : "forex"}`}>{trader.type}</span>
        </div>
        <button className={`ct-copy-btn ${copied ? "ct-copied" : ""}`} onClick={() => onCopy(trader)}>
          {copied ? "Following ✓" : "Copy"}
        </button>
      </div>

      <div className="ct-stats">
        <div><span>ROI (30D)</span><strong className="ct-green">+{trader.roi}%</strong></div>
        <div><span>Win Rate</span><strong>{trader.win}%</strong></div>
        <div><span>Followers</span><strong>{compact(trader.followers)}</strong></div>
        <div><span>Risk Score</span><strong className={`ct-risk ct-risk-${trader.risk.toLowerCase()}`}>{trader.risk}</strong></div>
      </div>

      <PerformanceLine values={trader.curve} risk={trader.risk} />
      <div className="ct-card-footer">
        <div><span>Copiers</span><strong>{trader.copiers.toLocaleString()}</strong></div>
        <div><span>AUM</span><strong>{money(trader.aum)}</strong></div>
        <div><span>Return</span><strong className="ct-green">+{trader.ret.toFixed(2)}%</strong></div>
      </div>
      <button className="ct-details-btn" onClick={() => onDetails(trader)}>View trader details <span>→</span></button>
    </article>
  );
}

export default function CopyTrading() {
    const navigate = useNavigate();

  const [market, setMarket] = useState("All");
  const [filter, setFilter] = useState("Top Rated");
  const [search, setSearch] = useState("");
  const [copied, setCopied] = useState([]);
  const [selected, setSelected] = useState(null);
  const [budget, setBudget] = useState("100");
  const [riskLimit, setRiskLimit] = useState("1.5");
  const [notice, setNotice] = useState("");
  const [firestoreTraders, setFirestoreTraders] = useState([]);
  const [loadingTraders, setLoadingTraders] = useState(true);
  const [tradersError, setTradersError] = useState("");
  const [allocating, setAllocating] = useState(false);
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(true);
 
  const [username, setUsername] = useState("");
  const [availableBalance, setAvailableBalance] = useState(0);
  const [balanceLoading, setBalanceLoading] = useState(true);
  


  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "tradingcoping"),
      (snapshot) => {
        const loaded = snapshot.docs.map((doc) => ({
          ...doc.data(),
          firestoreId: doc.id,
        }));
  
        setFirestoreTraders(loaded);
        setTradersError("");
        setLoadingTraders(false);
      },
      (error) => {
        console.error("Firestore traders error:", error);
        setTradersError("Imeshindwa kupakia traders kutoka Firestore.");
        setLoadingTraders(false);
      }
    );
  
    return () => unsubscribe();
  }, []);
  

 
useEffect(() => {
    const storedUsername = localStorage.getItem("username")?.trim();
  
    console.log("Username kutoka localStorage:", storedUsername);
  
    if (!storedUsername) {
      setNotice("Username haipo kwenye localStorage. Tafadhali ingia tena.");
      setBalanceLoading(false);
      return;
    }
  
    setUsername(storedUsername);
  
    const userQuery = query(
      collection(db, "users"),
      where("username", "==", storedUsername),
      limit(1)
    );
  
    const unsubscribe = onSnapshot(
      userQuery,
      (snapshot) => {
        console.log("User documents found:", snapshot.size);
  
        if (snapshot.empty) {
          setAvailableBalance(0);
          setNotice(`Akaunti ${storedUsername} haijapatikana kwenye usersfield.`);
        } else {
          const userData = snapshot.docs[0].data();
  
          console.log("usdtBalanceOther:", userData.usdtBalanceOther);
  
          const balance = Number(userData.usdtBalanceOther ?? 0);
  
          setAvailableBalance(
            Number.isFinite(balance) ? balance : 0
          );
          setNotice("");
        }
  
        setBalanceLoading(false);
      },
      (error) => {
        console.error("Balance loading error:", error);
        setNotice("Imeshindwa kusoma salio kutoka Firestore.");
        setBalanceLoading(false);
      }
    );
  
    return () => unsubscribe();
  }, []);
  

  const allTraders = useMemo(() => {
    const liveTraders = firestoreTraders.map((trader, index) => {
      const isCrypto = trader.type === "Crypto";
      const pairs = isCrypto ? CRYPTO_PAIRS : FOREX_PAIRS;
  
      return {
        ...trader,
        id: trader.firestoreId,
        pair: trader.pair || pairs[index % pairs.length],
        curve: Array.isArray(trader.curve)
          ? trader.curve
          : [30, 40, 50, 45, 60],
        roi: Number(trader.roi) || 0,
        win: Number(trader.win) || 0,
        followers: Number(trader.followers) || 0,
        copiers: Number(trader.copiers) || 0,
        aum: Number(trader.aum) || 0,
        ret: Number(trader.ret) || 0,
        risk: trader.risk || "Medium",
        name: trader.name || "Trader",
        style: trader.style || "Copy Trading",
        type: trader.type || "Forex",
        avatar: trader.avatar || "👤",
      };
    });
  
    return liveTraders;
  }, [firestoreTraders]);




  const visibleTraders = useMemo(() => {
    const searchText = search.trim().toLowerCase();
  
    let result = allTraders.filter((trader) => {
      const matchesMarket =
        market === "All" || trader.type === market;
  
      const matchesSearch =
        (trader.name || "").toLowerCase().includes(searchText) ||
        (trader.style || "").toLowerCase().includes(searchText) ||
        (trader.type || "").toLowerCase().includes(searchText);
  
      return matchesMarket && matchesSearch;
    });
  
    if (filter === "Highest ROI") {
      result.sort((a, b) => b.roi - a.roi);
    } else if (filter === "Most Copied") {
      result.sort((a, b) => b.copiers - a.copiers);
    } else if (filter === "Low Risk") {
      result = result.filter((trader) => trader.risk === "Low");
    } else {
      result.sort((a, b) => b.win - a.win);
    }
  
    return result;
  }, [allTraders, market, filter, search]);

  function toggleCopy(trader) {
    if (copied.includes(trader.id)) {
      setCopied((old) => old.filter((id) => id !== trader.id));
      setNotice(`Real: umeacha kumfuatilia ${trader.name}. Hakuna trade halisi iliyofungwa.`);
    } else {
      setSelected(trader);
      setNotice("");
    }
  }


  async function confirmCopy() {
    if (!selected || allocating) return;
  
    const requestedAmount = Number(budget);
  
    if (
      budget.trim() === "" ||
      !Number.isFinite(requestedAmount) ||
      requestedAmount < 10
    ) {
      setNotice("Kiasi cha chini cha kuanza copy trading ni 10 USDT.");
      return;
    }
  
    if (!selected.pair) {
      setNotice("Trader huyu hana Trading Pair iliyowekwa.");
      return;
    }
  
    const currentUsername = localStorage.getItem("username")?.trim();
  
    if (!currentUsername) {
      setNotice("Tafadhali ingia tena kwenye akaunti yako.");
      return;
    }
  
    setAllocating(true);
    setNotice("");
  
    try {
      const userQuery = query(
        collection(db, "users"),
        where("username", "==", currentUsername),
        limit(2)
      );
  
      const userSnapshot = await getDocs(userQuery);
  
      if (userSnapshot.size !== 1) {
        throw new Error("USER_DOCUMENT_NOT_FOUND");
      }
  
      const balance = Number(
        userSnapshot.docs[0].data().usdtBalanceOther ?? 0
      );
      
      const requestedCents = Math.round(requestedAmount * 100);
      const balanceCents = Math.floor((balance + 1e-9) * 100);
      
      if (
        !Number.isFinite(balance) ||
        requestedCents > balanceCents
      ) {
        setNotice("Salio lako halitoshi kwa kiasi ulichochagua.");
        return;
      }
  
      navigate("/copy-trading/confirmed-order", {
        state: {
          trader: selected,
          traderId: selected.id,
          traderName: selected.name,
          traderUsername: selected.username || "",
          traderAvatar: selected.avatar,
          traderType: selected.type,
          traderStyle: selected.style,
      
          market: selected.type,
          pair: selected.pair,
      
          budget: String(requestedAmount),
          riskLimit,
          riskLevel: selected.risk,
          username: currentUsername,
      
          traderROI: selected.roi,
          winRate: selected.win,
          totalTrades: selected.totalTrades ?? 0,
          followers: selected.followers,
          copiers: selected.copiers,
          aum: selected.aum,
          returnRate: selected.ret,
      
          verified: selected.verified ?? false,
        },
      });

    } catch (error) {
      console.error("Copy trading validation error:", error);
      setNotice("Imeshindwa kuhakiki akaunti yako. Jaribu tena.");
    } finally {
      setAllocating(false);
    }
  }
  

  return (
    <div className="ct-page">
      

      {loadingTraders && (
  <p style={{ textAlign: "center", padding: 20 }}>
    Inapakia traders...
  </p>
)}

{tradersError && (
  <p style={{ textAlign: "center", padding: 20, color: "#ef5268" }}>
    {tradersError}
  </p>
)}

      <style>{`
        .ct-page{--ct-bg:#080d16;--ct-card:#101724;--ct-border:#202a3a;--ct-muted:#929db0;--ct-text:#f4f6fb;--ct-blue:#347ff5;min-height:100vh;padding:0 0 95px;background:var(--ct-bg);color:var(--ct-text);font-family:Inter,system-ui,-apple-system,sans-serif;box-sizing:border-box}
        .ct-page *{box-sizing:border-box}.ct-topbar{position:sticky;top:0;z-index:5;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:17px 18px;background:rgba(8,13,22,.97);border-bottom:1px solid var(--ct-border)}
        .ct-title{font-size:19px;font-weight:800}.ct-subtitle{margin-top:4px;font-size:11px;color:var(--ct-muted)}.ct-live{font-size:10px;color:#f5c45e;border:1px solid #695329;border-radius:20px;padding:6px 9px;white-space:nowrap}
        .ct-content{max-width:920px;margin:auto;padding:16px 14px}.ct-warning{background:#211c12;color:#f6cf7a;border:1px solid #59451e;padding:10px 12px;border-radius:10px;font-size:12px;line-height:1.5;margin-bottom:17px}
        .ct-overview{display:grid;grid-template-columns:repeat(3,1fr);gap:9px;margin-bottom:19px}.ct-overview>div{background:var(--ct-card);border:1px solid var(--ct-border);border-radius:12px;padding:12px 9px;min-width:0}.ct-overview span{display:block;color:var(--ct-muted);font-size:11px;margin-bottom:8px}.ct-overview strong{font-size:clamp(14px,3.8vw,21px)}
        .ct-section-title{font-size:15px;font-weight:750;margin:21px 0 12px}.ct-markets,.ct-filter-row{display:flex;gap:8px;overflow-x:auto;padding-bottom:12px;scrollbar-width:none}
        .ct-markets button,.ct-filter{border:1px solid var(--ct-border);background:#131b2a;color:#aab4c6;border-radius:24px;padding:10px 16px;font-size:12px;white-space:nowrap;cursor:pointer}.ct-markets button.active,.ct-filter.active{background:var(--ct-blue);color:white;border-color:var(--ct-blue)}
        .ct-search{display:flex;gap:8px;margin:5px 0 14px}.ct-search input{min-width:0;flex:1;border:1px solid var(--ct-border);background:var(--ct-card);color:white;padding:12px;border-radius:10px;outline:none}.ct-filter{padding:9px 12px}
        .ct-card{background:var(--ct-card);border:1px solid var(--ct-border);border-radius:19px;padding:16px;margin-top:13px;overflow:hidden}.ct-trader-head{display:flex;align-items:center;gap:11px;min-width:0}
        .ct-avatar-wrap{position:relative;flex:0 0 57px}.ct-avatar{height:57px;width:57px;display:grid;place-items:center;border-radius:50%;background:#222f43;font-size:31px;border:1px solid #344056}
        .ct-rank{position:absolute;z-index:1;top:-5px;left:-4px;background:#344054;color:white;border:2px solid var(--ct-card);border-radius:50%;min-width:23px;height:23px;text-align:center;line-height:19px;font-size:11px;font-weight:800}.ct-medal{background:#f6c94d;color:#1a1a1a}
        .ct-trader-info{min-width:0;flex:1}.ct-name{font-size:14px;font-weight:750;overflow-wrap:anywhere}.ct-verified{display:inline-grid;place-items:center;width:17px;height:17px;margin-left:5px;border:1px solid #438bff;border-radius:50%;color:#438bff;font-size:11px}.ct-style{color:var(--ct-muted);font-size:12px;margin-top:4px}
        .ct-market-tag{display:inline-block;font-size:10px;margin-top:5px;padding:3px 7px;border-radius:6px}.ct-market-tag.crypto{color:#ffc96b;background:#332719}.ct-market-tag.forex{color:#91b8ff;background:#1a2a43}
        .ct-copy-btn{border:0;background:var(--ct-blue);color:white;border-radius:24px;padding:10px 16px;font-weight:750;font-size:12px;cursor:pointer;white-space:nowrap}.ct-copy-btn.ct-copied{background:#143e35;color:#63e0b3;border:1px solid #267b62}
        .ct-stats{display:grid;grid-template-columns:1fr 1fr;gap:18px 12px;margin-top:23px}.ct-stats span,.ct-card-footer span{display:block;color:var(--ct-muted);font-size:12px;margin-bottom:6px}.ct-stats strong{font-size:15px}.ct-green{color:#42c99a!important}.ct-risk-low{color:#42c99a}.ct-risk-medium{color:#f5c14d}.ct-risk-high{color:#f45d70}
        .ct-performance{width:100%;height:78px;margin-top:14px;display:block;overflow:visible}.ct-card-footer{display:grid;grid-template-columns:repeat(3,1fr);gap:5px;border-top:1px solid #202938;padding-top:15px;margin-top:8px;text-align:center}.ct-card-footer strong{font-size:12px}
        .ct-details-btn{width:100%;margin-top:15px;padding:10px;border:1px solid var(--ct-border);background:transparent;color:#aab9d0;border-radius:10px;cursor:pointer;font-size:12px}.ct-details-btn span{color:#68a1ff;margin-left:4px}
        .ct-bottom-nav{position:fixed;z-index:20;bottom:0;left:0;right:0;display:grid;grid-template-columns:repeat(3,1fr);padding:11px 10px calc(11px + env(safe-area-inset-bottom));background:rgba(15,22,34,.98);border-top:1px solid var(--ct-border)}.ct-bottom-nav button{background:transparent;color:#8794a9;border:0;display:flex;flex-direction:column;align-items:center;gap:5px;font-size:11px;cursor:pointer}.ct-bottom-nav button.active{color:#75a7ff}.ct-bottom-nav svg{width:22px;height:22px}
        .ct-modal-backdrop{position:fixed;z-index:40;inset:0;display:grid;place-items:center;padding:16px;background:rgba(0,0,0,.72)}.ct-modal{width:100%;max-width:410px;padding:21px;background:#111a29;border:1px solid #2a3548;border-radius:18px;box-shadow:0 20px 80px #0008;max-height:90vh;overflow:auto}.ct-modal h3{margin:0 0 7px;font-size:19px}.ct-modal p{color:var(--ct-muted);font-size:12px;line-height:1.6}
        .ct-modal label{display:block;color:#bdc8da;font-size:12px;margin:15px 0 7px}.ct-modal input,.ct-modal select{width:100%;background:#0a111e;color:white;border:1px solid #303c50;padding:12px;border-radius:9px}.ct-modal-actions{display:flex;gap:9px;margin-top:18px}.ct-modal-actions button{flex:1;padding:12px 8px;border-radius:10px;cursor:pointer;font-weight:700}.ct-cancel{background:transparent;color:white;border:1px solid #39465a}.ct-confirm{background:var(--ct-blue);color:white;border:0}
        .ct-notice{margin:12px 0;padding:12px;border:1px solid #285a4c;border-radius:10px;background:#10251f;color:#8ee5c5;font-size:12px;line-height:1.5}.ct-empty{padding:30px 10px;text-align:center;color:var(--ct-muted)}
        @media(min-width:700px){.ct-content{padding:23px 22px}.ct-trader-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px;align-items:start}.ct-card{margin-top:0}.ct-topbar{padding-left:max(22px,calc((100vw - 876px)/2));padding-right:max(22px,calc((100vw - 876px)/2))}}
      `}</style>



      <header className="ct-topbar">
        <div><div className="ct-title">BFC Copy Trading</div><div className="ct-subtitle">Crypto & Forex · Trader marketplace</div></div>
        <span className="ct-live">●Real </span>
      </header>

      <main className="ct-content">
      
        <div className="ct-overview">0
          <div><span>Traders</span><strong>{visibleTraders.length}</strong></div>
          <div><span>Following (Real)</span><strong>{copied.length}</strong></div>
          <div><span>Markets</span><strong>45 + 45</strong></div>
        </div>

        <div className="ct-section-title">Chagua Market</div>
     
<div className="ct-markets">
  <button onClick={() => setMarket("All")} className={market === "All" ? "active" : ""}>
    🌐 All Markets
  </button>
  <button onClick={() => setMarket("Crypto")} className={market === "Crypto" ? "active" : ""}>
    ₿ Crypto
  </button>
  <button onClick={() => setMarket("Forex")} className={market === "Forex" ? "active" : ""}>
    💱 Forex
  </button>
  <button onClick={() => setMarket("Sport")} className={market === "Sport" ? "active" : ""}>
    ⚽ Sport
  </button>
  <button onClick={() => setMarket("Futures")} className={market === "Futures" ? "active" : ""}>
    📈 Futures
  </button>
  <button onClick={() => setMarket("Stocks")} className={market === "Stocks" ? "active" : ""}>
    🏦 Stocks
  </button>
</div>

        <div className="ct-search"><input value={search} onChange={(e)=>setSearch(e.target.value)} placeholder="🔍 Tafuta trader kwa jina..." /></div>
        <div className="ct-section-title">Top Traders</div>
        <div className="ct-filter-row">{filters.map((f)=><button key={f} className={`ct-filter ${filter===f?"active":""}`} onClick={()=>setFilter(f)}>{f}</button>)}</div>
        {notice && <div className="ct-notice">{notice}</div>}
        <div className="ct-trader-grid">
          {visibleTraders.map((trader,index)=><TraderCard key={trader.id} trader={trader} rank={index+1} copied={copied.includes(trader.id)} onCopy={toggleCopy} onDetails={setSelected}/>)}
        </div>
        {visibleTraders.length===0 && <div className="ct-empty">Hakuna trader aliyepatikana.</div>}
      </main>

     

      {selected && <div className="ct-modal-backdrop" onClick={()=>setSelected(null)}>
        <section className="ct-modal" onClick={(e)=>e.stopPropagation()}>
          <h3>{selected.name}</h3><p>{selected.type} · {selected.style} · BFCTrade  profile</p>
          <div className="ct-stats">
            <div><span>ROI (30D)</span><strong className="ct-green">+{selected.roi}%</strong></div><div><span>Win Rate</span><strong>{selected.win}%</strong></div>
            <div><span>Risk</span><strong className={`ct-risk ct-risk-${selected.risk.toLowerCase()}`}>{selected.risk}</strong></div><div><span>Copiers</span><strong>{selected.copiers.toLocaleString()}</strong></div>
          </div>

          <div className="ct-balance-info">
  <span>Available Balance</span>
  <strong>
   
{balanceLoading
  ? "Loading..."
  : `${availableBalance.toLocaleString()} USDT`}

  </strong>
</div>

<label>Real allocation (USDT)</label>

<div className="ct-allocation-row">
  <input
    type="number"
    min="10"
    max={availableBalance}
    step="0.01"
    value={budget}
    onChange={(e) => setBudget(e.target.value)}
    disabled={balanceLoading || allocating}
  />

  <button
    type="button"
    className="ct-max-btn"
    onClick={() => setBudget(availableBalance.toFixed(2))}
    disabled={
      balanceLoading ||
      allocating ||
      availableBalance < 10
    }
  >
    Max Amount
  </button>
</div>

          <label>Maximum loss alert (%)</label><select value={riskLimit} onChange={(e)=>setRiskLimit(e.target.value)}><option value="1.5">1.5%</option><option value="2.5">2.5%</option><option value="2.8">2.8%</option><option value="3.5">3.5%</option></select>
          <p>Hii ni real tu. Allocation na risk alert hazitaanzisha order halisi.</p>
          <div className="ct-modal-actions"><button className="ct-cancel" onClick={()=>setSelected(null)}>Cancel</button>
   
<button
  className="ct-confirm"
  onClick={confirmCopy}
  disabled={allocating}
>
  {allocating ? "Processing..." : "Start Copy (Real)"}
</button>

          </div>
        </section>
      </div>}
    </div>
  );
}
